import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';

export const componentStyles = css.raw({
  '&.Review': {
    border: 'none',
    padding: 0,
  },
});

export const propertyPhotoStyles = css.raw({
  backgroundColor: 'aqua.600',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  borderRadius: '100',
  marginRight: {
    base: '200',
    md: '400',
  },
  minHeight: '104px',
  width: {
    base: '93px',
    md: '156px',
  },
  alignSelf: 'center',
  flexShrink: 0,
});

export const addressDetailsStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flexGrow: 1,
  minWidth: 0,
});

// this needs to be <li/> to comply with its parent <ul/>
export const StyledVerticalDivider = styled('li', {
  base: {
    alignSelf: 'center',
    backgroundColor: 'gray.400',
    display: 'inline-flex',
    height: '12px',
    margin: { base: '0 {spacing.100}', md: '0 {spacing.200}' },
    width: '1px',
  },
});
